import React from 'react'

const MechandiseBar = ({commodityCode='',taricCode='',commercialDescription,itemValue='',originCountry,preference,serviceType}) => {
 const newCommodityCode = serviceType === 'IM' ? commodityCode+taricCode : commodityCode
 const updatedCommercialDescription = commercialDescription && commercialDescription.split(' ')
 let updatedCommercialDescriptionString = updatedCommercialDescription && updatedCommercialDescription[0].toUpperCase()
if(updatedCommercialDescriptionString && updatedCommercialDescription[1]){
  updatedCommercialDescriptionString = updatedCommercialDescriptionString.toUpperCase()+' ...'
}

  return (
         <div style={{display:'flex', width:'100%',color:'#1765ae', fontWeight:'bold'}}>

          <div style={{flexBasis:'20%'}}>
          <span title='Commodity Code' className='merch-accordian'>
            {newCommodityCode    || ''}
          </span>
          </div>

          <div style={{flexBasis:'40%'}}>
          <span title='Commercial Description'>
            {updatedCommercialDescriptionString || ''}
          </span>
          </div>

          <div style={{flexBasis:'15%'}}>
          <span title='Item Value' className='merch-accordian'>
            {parseFloat(itemValue === '' ? '0.00' : itemValue).toFixed(2)}
          </span>
          </div>

          <div style={{flexBasis:'20%'}}>
          <span title='Country Of Origin' className='merch-accordian'   >
            {originCountry || ''}
          </span>
          </div>

          <div style={{flexBasis:'15%'}}>
          <span title='Preference' className='merch-accordian'>
            {preference || ''}
          </span>
          </div>
      </div>
   

 
  )
}

export default MechandiseBar
